<template>
	<section class="page-section">
		<div class="wrapper">
			<div class="addresses">
				<section v-show="!pawnId" class="addresses-tabs">
					<a class="addresses-tabs__item" :class="{active : currentView === 'map'}" @click="setCurrentViewMode('map')">На карте</a>
					<a class="addresses-tabs__item" :class="{active : currentView === 'list'}" @click="setCurrentViewMode('list')">Списком</a>
				</section>

				<pawnshops-filter :filter="filter" :pawn-id="pawnId" :city-id="cityId" :region-id="regionId" @region:changed="$emit('region:changed', $event)" @city:changed="$emit('city:changed', $event)" ></pawnshops-filter>
				<template v-if="!pawnId">
					<div class="addresses-filter__bottom" v-show="!pawnsList.length">
						<p class="addresses-filter__bottom-title">К сожалению, мы не нашли ломбарды по заданным параметрам</p>
						<p class="addresses-filter__bottom-subtitle">Попробуйте сбросить выбранные фильтры</p>
						<button class="btn color addresses-filter__bottom-reset" @click="refresh()">Сбросить фильтры
						</button>
					</div>
				</template>
				<div v-if="false" class="book-pawn">
					<div class="book-pawn__title">
						Не жди в очереди, <br> запишись на удобное время
					</div>
					<div class="book-pawn__btn"> 
						<a class="btn color bold" href="#pawn-book" data-fancybox-modal>Запишись в ломбард</a>
					</div>
				</div>

				<pawnshops-map v-if="currentView === 'map'"></pawnshops-map>
				<pawnshops-list :sitesdata="sitesdata" v-else-if="currentView === 'list'"></pawnshops-list>
			</div>
		</div>
	</section>
</template>

<script>
import PawnshopsFilter from "@/components/Pawnshops/PawnshopsFilter";
import PawnshopsMap from "@/components/Pawnshops/PawnshopsMap";
import PawnshopsList from "@/components/Pawnshops/PawnshopsList";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
	name: 'PawnsMain',
	emits : [ 'region:changed', 'city:changed' ],
	components: {PawnshopsList, PawnshopsMap, PawnshopsFilter},
	props: {
		pawnId: {
			type: Number,
			default: 0
		},
		cityId: {
			type: [ Number, String ],
			default: 0
		},
		regionId: {
			type: [ Number, String ],
			default: 0
		},
		sitesdata: {
			type: Object,
			required: true
		},
		filter: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {}
	},
	computed: {
		...mapGetters({
			currentView: 'pawns/getCurrentViewMode',
			pawnsList: 'pawns/getPawnsList',
		})
	},
	methods: {
		refresh() {
			this.clearFilter()
			this.loadPawns()
		},
		...mapMutations({
			setCurrentViewMode: 'pawns/setCurrentViewMode',
			clearFilter: 'pawns/clearAdditionalFilters',
		}),
		...mapActions({
			loadPawns: 'pawns/loadPawnsList'
		})
	}
}
</script>

<style scoped>

</style>
